import qs from "qs";
import { sendRecurrentPaymentsReport } from "../../infrastructure/repository/recurrent-payments-repository";
import { showErrorMessage } from "../commons/show-error-message";
import { showSuccessMessage } from "../commons/show-success-message";
import { translate as t } from "../../infrastructure/translate/localization";
import Datetime from "../../v2/domain/common/entities/Datetime";

export default async function sendRecurrentPaymentReportEmail({
  companyId,
  category,
  email,
  filters = {},
}: {
  companyId: string;
  category: string;
  email: string;
  filters?: Record<string, string>;
}): Promise<void> {
  const { minRequestedAt, ...restOfFilters } = filters;
  const params = {
    category,
    recipientEmail: email,
    minRequestedAt:
      minRequestedAt || new Datetime().subMonths(6).toDatetimeString(),
    ...restOfFilters,
  };
  showSuccessMessage(t("recurrent-payments-section.generating-report-file"));
  sendRecurrentPaymentsReport({
    companyId,
    params: qs.stringify(params, { skipNulls: true }),
  })
    .then(() =>
      showSuccessMessage(
        t(
          "recurrent-payments-section.file-generated-correctly-check-your-email"
        )
      )
    )
    .catch(() => showErrorMessage(t("common-messages.basic-error-message")));
}
